import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";

export const useViewCategory = ({
  page,
  limit,
  q,
  includeInactive = true,
} = {}) => {
  const isPaginated = page !== undefined && limit !== undefined;
  const trimmedQ = q?.trim?.() ?? "";

  return useQuery({
    queryKey: isPaginated
      ? ["viewcategory", page, limit, trimmedQ, includeInactive]
      : ["viewcategory", includeInactive],
    queryFn: async () => {
      const params = { includeInactive };
      if (isPaginated) {
        params.page = page;
        params.limit = limit;
        if (trimmedQ) params.q = trimmedQ;
      }

      const res = await api.get("/category/all", { params });

      if (isPaginated) {
        const parsed = parsePaginatedResponse(
          res.data,
          ["categories", "category"],
          limit
        );
        return {
          categories: parsed.items,
          pagination: parsed.pagination,
        };
      }

      return res.data;
    },
    placeholderData: isPaginated
      ? (previousData) => previousData
      : undefined,
    staleTime: isPaginated ? 60_000 : undefined,
  });
};
